// extracted by mini-css-extract-plugin
module.exports = {"headerStyles":"TagsNews_headerStyles__4bS0l"};